import React from 'react';

// Case text is plain data. *word* becomes emphasis; nothing is ever injected as HTML.
export const renderEmphasis = (text) =>
  text.split(/\*([^*]+)\*/).map((part, index) => (index % 2 === 1 ? <em key={index}>{part}</em> : part));

// A newline inside a title marks where the heading should break.
export const renderTitle = (title) =>
  title.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {index > 0 && <br />}
      {line}
    </React.Fragment>
  ));

export const plainTitle = (title) => title.replace(/\s*\n\s*/g, ' ');

export const caseNumber = (number) => String(number).padStart(3, '0');

// Difficulty runs 1 (easiest) to 5 and is spelled out, never drawn as stars.
export const difficultyLabel = (difficulty) => `Difficulty level: ${Math.max(1, Math.min(5, difficulty))}`;

// Suspect write-ups start with the suspect's name; show that name in bold.
export const renderSuspectWriteup = (suspect) =>
  suspect.description.startsWith(suspect.name) ? (
    <>
      <strong>{suspect.name}</strong>
      {suspect.description.slice(suspect.name.length)}
    </>
  ) : (
    suspect.description
  );
